const Footer = () => {
  return (
    <footer className="care-plan-footer">
      <div className="container">
        <div className="footer-content">
          {/* QMED Logo */}
          <div className="footer-logo">
            <img
              src="/images/qmed logo.png"
              alt="Qmed Logo"
              style={{ height: '3rem', marginRight: '0.5rem' }}
              onError={(e) => {
                e.target.style.display = 'none'
                e.target.nextSibling.style.display = 'inline'
              }}
            />
            <span style={{ color: '#0fbab2', fontSize: '2rem', marginRight: '0.5rem', display: 'none' }}>❤️</span>
          </div>
          <p className="footer-made-with">Made with ❤️ for nurses</p>
          <p className="footer-copyright">© 2025 Qmed Nursing Care Plans. All rights reserved.</p>
          <p className="footer-disclaimer">
            <strong>Disclaimer:</strong> This care plan is for educational purposes. Always follow institutional protocols and clinical judgment.
          </p>
        </div>
      </div>
    </footer>
  )
}

export default Footer
